import React from 'react';
import { AjusteDeEstoqueContent } from './AjusteDeEstoqueContent';
import { AjusteDeEstoqueProvider } from './context/AjusteDeEstoqueContext';

const AjusteDeEstoque: React.FC = () => {
  return (
    <AjusteDeEstoqueProvider>
      <AjusteDeEstoqueContent />
    </AjusteDeEstoqueProvider>
  );
};

export default AjusteDeEstoque;
